import React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {
  faSpinner,
} from '@fortawesome/fontawesome-free-solid';

import 'assets/scss/loading.css';

const Loading = ({ title }) => {
  const loadingText = title || "Loading";

  return (
    <div className="loading-container text-muted">
      <FontAwesomeIcon icon="spinner" pulse /><br />
      <span className="text-muted">
        {loadingText}
      </span>
    </div>
  )
}

export default Loading;



// WEBPACK FOOTER //
// ./src/utils/Loading.js